import { useEffect } from 'react';
import useGetShoppingCartQuery from '../../../../queries/useGetShoppingCartQuery';
import useHomeStore from '../../../../store/homeStore';
import useAuthStore from '../../../../store/authStore';
import useCartStore from '../../../../store/cartStore';
import { useMatch } from 'react-router-dom';

const useHeaderState = () => {
  const setShoppingItems = useCartStore((state) => state.setShoppingItems);
  const {
    showPricingModal,
    showContactModal,
    setShowCart,
    showCart,
    setShowLogin,
    showLogin,
    showDownloadApiModal,
    showAdvertisingBanner,
    showFeaturesModal,
    advertisingBannerButtonText,
  } = useHomeStore();
  const isPaymentSuccessRoute = useMatch({
    path: '/payment/success',
    end: true,
  });

  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const shoppingCart = useGetShoppingCartQuery();

  useEffect(() => {
    if (!isAuthenticated) return;

    if (!isPaymentSuccessRoute) {
      shoppingCart.refetch();
      return;
    }

    const timer = setTimeout(() => {
      shoppingCart.refetch();
    }, 5000);

    return () => clearTimeout(timer);
  }, [isAuthenticated, isPaymentSuccessRoute]);

  useEffect(() => {
    const data = shoppingCart.data;
    if (!data) return;
    setShoppingItems(data.shoppingItems);
  }, [shoppingCart.data, setShoppingItems]);

  const handleCart = () => {
    if (isAuthenticated) {
      setShowCart(!showCart);
    } else {
      setShowLogin(!showLogin);
    }
  };

  return {
    showPricingModal,
    showContactModal,
    showDownloadApiModal,
    showFeaturesModal,
    showCart,
    showLogin,
    advertisingBannerButtonText,
    isAuthenticated,
    shoppingCart,
    handleCart,
    showAdvertisingBanner,
  };
};

export default useHeaderState;
